module.exports = __webpack_public_path__ + "img/share-guide.e7c865ef.png";